import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'
import type { AppRole } from '../lib/supabaseClient'
import { useFeature } from '../providers/FeatureFlagProvider'

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { session, loading } = useAuth()
  const location = useLocation()
  if (loading) return children // allow render; pages can show skeletons
  if (!session) return <Navigate to="/login" state={{ from: location }} replace />
  return children
}

export function RequireRole({ role, children }: { role: AppRole | AppRole[]; children: JSX.Element }) {
  const { role: userRole } = useAuth()
  if (!userRole) return <Navigate to="/login" replace />
  const roles = Array.isArray(role) ? role : [role]
  if (!roles.includes(userRole)) return <Navigate to="/" replace />
  return children
}

export function GateFlag({ flag, children }: { flag: 'what_if' | 'optimizers'; children: JSX.Element }) {
  const { isEnabled } = useFeature()
  if (!isEnabled(flag)) return <Navigate to="/" replace />
  return children
}


